import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { type DynamicAction } from '@shared/registry';

import { type ImageButtonConfig } from './image-button.types';

@Component({
  selector: 'app-image-button',
  templateUrl: './image-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageButton {
  readonly config = input.required<ImageButtonConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected onClick(): void {
    const action = this.config().action;
    if (action) {
      this.action.emit(action);
    }
  }
}
